module.exports = __webpack_public_path__ + "static/poster2-0419b61b41497dec19593431fe1ca8e6.jpg";